import script from "./unactived-device-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./unactived-device-popup.vue?vue&type=script&lang=ts&setup=true"

import "./unactived-device-popup.vue?vue&type=style&index=0&id=ce5a2dd8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce5a2dd8"]])

export default __exports__